export const BOOK_DEMO_URL =
  process.env.REACT_APP_BOOK_DEMO_URL ||
  'https://cal.com/rishi-gaddamanugu-6qssau/30min';

export const BOOK_DEMO_PAGE_PATH = '/book-demo';

export const BOOK_DEMO_LABEL = 'Book a demo';

/** Shorter label for the fixed header nav on very narrow viewports. */
export const BOOK_DEMO_NAV_LABEL = 'Book demo';

/** Cal.com calLink slug (username/event-type) from the booking URL. */
export function resolveBookDemoCalLink(bookDemoUrl = BOOK_DEMO_URL) {
  try {
    const url = new URL(bookDemoUrl);
    return url.pathname.replace(/^\//, '').replace(/\/$/, '');
  } catch {
    return 'rishi-gaddamanugu-6qssau/30min';
  }
}

/**
 * Booking-type cards shown on /book-demo before the full-screen Cal embed.
 * Add entries here when new Cal event types are available.
 */
export const BOOK_DEMO_EVENT_TYPES = [
  {
    id: 'product-demo',
    title: 'Product demo',
    durationLabel: '30 min',
    description: 'Workspaces, client review, and publishing walkthrough.',
    calLink: resolveBookDemoCalLink(),
  },
];

/** @deprecated Use resolveBookDemoCalLink with @calcom/embed-react — raw iframe /embed URLs render blank. */
export function resolveBookDemoEmbedUrl(bookDemoUrl = BOOK_DEMO_URL) {
  return resolveBookDemoCalLink(bookDemoUrl);
}
